export default __webpack_public_path__ + "static/media/shutterstock_v250877421.773e0364.webm";